import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { BaseComponent } from 'src/app/common/base/base.component';
import { RelatedLink } from 'src/app/common/models/related-link';
import { RelatedLinkBase } from 'src/app/components/catalogs/navigation-links/link/related-link-base';

import { AddRelatedLinkComponent } from '../add-related-link/add-related-link.component';

@Component({
  selector: 'related-link-chips',
  templateUrl: './related-link-chips.component.html',
  styleUrls: ['./related-link-chips.component.scss']
})
export class RelatedLinkChipsComponent extends BaseComponent implements OnInit, OnChanges {
  @Input() placeholder!: string;
  @Input() disabled?: boolean;
  @Input() formId?: number;
  @Input() relatedLinks?: RelatedLinkBase[];
  @Input() relatedLinksJson?: string;
  @Input() documentNameOrHyperlinkPlaceholder?: string;
  @Input() webAddressPlaceholder?: string;
  @Input() hilite?: boolean | null;
  @Input() label?: string;
  @Input() showDateField?: boolean = false;
  @Input() dateLabel?: string;
  @Input() control?: FormControl | null;

  @Output() onEdited = new EventEmitter<RelatedLinkBase[]>();

  public get chipInputCtrl(): AbstractControl | null { return this.formGroup?.get("chipInputCtrl"); }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.buildForm();
    if (!this.label) this.label = 'Related Documents and Links';
    if (changes['relatedLinksJson']) this.relatedLinks = this.utils.JSONparse(this.relatedLinksJson);
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      chipInputCtrl: [{ value: null }],
    });
    if (this.control)
      this.disabled = this.control.disabled;
    if (this.disabled) this.formGroup.disable(); else this.formGroup.enable();
  }

  open() {
    if (!this.disabled) {
      const dialog = this.dialog.open(AddRelatedLinkComponent, {
        maxWidth: '800px',
        width: '450px',
        data: {
          obj: {
            Text: null,
            URL: null,
            Date: null,
          } as RelatedLink,
          DocumentNameOrHyperlinkPlaceholder: this.documentNameOrHyperlinkPlaceholder,
          WebAddressPlaceholder: this.webAddressPlaceholder,
          withDate: this.showDateField,
          dateLabel: this.dateLabel
        }
      });
      dialog.afterClosed().subscribe((result: RelatedLink) => {
        if (result) {
          if (!this.relatedLinks) this.relatedLinks = [];
          this.relatedLinks?.push({
            formID: this.formId ?? 0,
            text: result.Text ?? '',
            url: result.URL ?? '',
            date: result.date
          });
          this.onEdited.emit(this.relatedLinks);
        }
      });
    }
  }

  remove(relatedLink: RelatedLinkBase) {
    const index = this.relatedLinks?.indexOf(relatedLink) ?? -1;

    if (index >= 0) {
      this.relatedLinks?.splice(index, 1);
      this.onEdited.emit(this.relatedLinks);
    }
  }

}
